<template>
  <div>
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          :disabled="disabled"
          :x-large="xLargeButton"
          :large="largeButton"
          :small="smallButton"
          :v-bind="attrs"
          v-on="on"
        >
          {{ buttonCaption }}
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item @click="showEmissionDialogButtonClickEvent">
          <v-list-item-title> 排出事業者から選択 </v-list-item-title>
        </v-list-item>
        <v-list-item @click="showTraderDialogButtonClickEvent">
          <v-list-item-title>
            {{ traderButtonName }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <!-- 排出 -->
    <choose-emission-modal
      :enable="enableEmissionDialog"
      :without-invisible="withoutInvisible"
      :without-general-form="withoutGeneralForm"
      @selected="registerEmissionButtonClickEvent"
      @close="closeDialog"
    />
    <!-- 収運・処分 -->
    <choose-trader-modal
      :enable="enableTraderDialog"
      :without-invisible="withoutInvisible"
      :without-non-reporting="withoutNonReporting"
      :without-non-subscribe="withoutNonSubscribe"
      :include-general-waste-disposer="includeGeneralWasteDisposer"
      :with-none-location="withNoneLocation"
      @selected="registerTraderButtonClickEvent"
      @close="closeDialog"
    />
    <!-- /収運・処分 -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import PrefectureList from "@/mixins/PrefectureList";
import ChooseEmissionModal from "./ChooseEmissionModal.vue";
import ChooseTraderModal from "./ChooseTraderModal.vue";

/**
 * 取引先選択ダイアログの呼び出し
 * 選択肢として、排出、または収運・処分を一覧形式で表示し、呼び出し元画面に選択した結果を返します。
 *
 * 呼び出し元は以下のコールバックを定義してください。
 * ・choseEmissionCallback
 *  @return emission [Object] 排出
 *  ・choseTraderCallback
 *  @return trader [Object] 収運・処分業者
 */
export default {
  name: "ChooseSupplierButton",
  components: {
    ChooseEmissionModal,
    ChooseTraderModal,
  },
  mixins: [PrefectureList],
  props: {
    buttonCaption: {
      type: String,
      default: () => "取引先を選択",
    },
    xLargeButton: {
      type: Boolean,
      default: () => false,
    },
    largeButton: {
      type: Boolean,
      default: () => false,
    },
    smallButton: {
      type: Boolean,
      default: () => false,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    exclusionIds: {
      type: Array,
      default: () => [],
    },
    searchType: {
      type: String,
      default: () => null,
    },
    withoutInvisible: {
      type: Boolean,
      default: () => false,
    },
    withoutNonReporting: {
      type: Boolean,
      default: () => false,
    },
    withoutNonSubscribe: {
      type: Boolean,
      default: () => false,
    },
    includeGeneralWasteDisposer: {
      type: Boolean,
      default: () => false,
    },
    withoutGeneralForm: {
      type: Boolean,
      default: () => false,
    },
    withNoneLocation: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      enableEmissionDialog: false,
      enableTraderDialog: false,
      traderButtonName: null,
    };
  },
  computed: {},
  watch: {
  },
  created() {
    this.setTitle()
  },
  methods: {
    setTitle() {
      if (this.searchType === "transport") {
        this.traderButtonName = "収運業者から選択";
      } else if (this.searchType === "trader") {
        this.traderButtonName = "処分業者から選択";
      } else {
        this.traderButtonName = "収運・処分業者から選択";
      }
    },

    /**
     * 排出事業者から選択メニュー クリックイベント
     */
    showEmissionDialogButtonClickEvent() {
      this.enableEmissionDialog = true;
    },
    /**
     * 収運・処分業者から選択メニュー クリックイベント
     */
    showTraderDialogButtonClickEvent() {
      this.enableTraderDialog = true;
    },
    /**
     * 排出事業者 反映ボタン クリックイベント
     * 呼び出し元で定義されたコールバックをキックし、選択された排出事業者情報を返します.
     */
    registerEmissionButtonClickEvent(item) {
      this.$emit("choseSupplierCallback", item);
      this.closeDialog();
    },
    /**
     * 収運・処分業者 反映ボタン クリックイベント
     * 呼び出し元で定義されたコールバックをキックし、選択された収運・処分業者情報を返します.
     */
    registerTraderButtonClickEvent(item) {
      this.$emit("choseSupplierCallback", item);
      this.closeDialog();
    },
    /**
     * ダイアログを閉じる
     */
    closeDialog() {
      this.enableEmissionDialog = false;
      this.enableTraderDialog = false;
    },
    scrollToTop() {
      const elements = document.getElementsByClassName("v-dialog--active");
      if (!elements || !elements.length) {
        // 要素が取得できなかった場合は終了
        return;
      }
      const cards = elements[0].getElementsByClassName("card-layer");
      if (!cards || !cards.length) {
        // 要素が取得できなかった場合は終了
        return;
      }
      cards[0].scrollTop = 0;
    },
  },
};
</script>
